import React from 'react';
import { Input } from '../common';
import Select from '../common/Select';
import { 
  SCHEDULE_STATUS_OPTIONS,
  AUDITOR_ORG_OPTIONS
} from './constants';

const TableFilters = ({ filters, onFilterChange }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log('Filter changed:', name, value); // Debug log
    onFilterChange({ ...filters, [name]: value });
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    console.log('Date filter changed:', name, value); // Debug log
    if (name.endsWith('End')) {
      // For end date, ensure it's not before the start date
      const startDate = name === 'scheduledDateEnd' ? filters.scheduledDate : filters.dueDate;
      if (!startDate || value >= startDate) {
        onFilterChange({ ...filters, [name]: value });
      }
    } else {
      // For start date, reset end date if it's now after the end date
      const endDateField = `${name}End`;
      const endDate = filters[endDateField];
      if (endDate && value > endDate) {
        onFilterChange({ 
          ...filters, 
          [name]: value,
          [endDateField]: value
        });
      } else {
        onFilterChange({ ...filters, [name]: value });
      }
    }
  };

  return (
    <div className="bg-gray-50 p-4 rounded-lg mb-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Status Filter */}
        <Select
          label="Status"
          name="status"
          value={filters.status}
          onChange={handleInputChange}
          options={[
            { value: '', label: 'All Statuses' },
            ...SCHEDULE_STATUS_OPTIONS
          ]}
        />

        {/* Auditor Organization Filter */}
        <Select
          label="Auditor Organization"
          name="auditorOrg"
          value={filters.auditorOrg}
          onChange={handleInputChange}
          options={[
            { value: '', label: 'All Organizations' },
            ...AUDITOR_ORG_OPTIONS
          ]}
        />

        {/* Scheduled Date Range */}
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Scheduled Date Range
          </label>
          <div className="flex space-x-2">
            <Input
              type="date"
              name="scheduledDate"
              value={filters.scheduledDate}
              onChange={handleDateChange}
              placeholder="From"
            />
            <Input
              type="date"
              name="scheduledDateEnd"
              value={filters.scheduledDateEnd}
              onChange={handleDateChange}
              min={filters.scheduledDate}
              placeholder="To"
            />
          </div>
        </div>

        {/* Due Date Range */}
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Due Date Range
          </label>
          <div className="flex space-x-2">
            <Input
              type="date"
              name="dueDate"
              value={filters.dueDate}
              onChange={handleDateChange}
              placeholder="From"
            />
            <Input
              type="date"
              name="dueDateEnd"
              value={filters.dueDateEnd}
              onChange={handleDateChange}
              min={filters.dueDate}
              placeholder="To"
            />
          </div>
        </div>

        {/* Search Input */}
        <div className="lg:col-span-4">
          <Input
            label="Search"
            name="search"
            value={filters.search}
            onChange={handleInputChange}
            placeholder="Search by item ID, vendor, station, or auditor..."
          />
        </div>
      </div>
    </div>
  );
};

export default TableFilters;
